var escape = require("../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.list[data-v-4e00f6ee] {\n  display: flex;\n  flex-wrap: wrap-reverse;\n  margin-top: 2rem;\n}\n.apple[data-v-4e00f6ee] {\n  width: 40px;\n  height: 40px;\n  background-image: url(" + escape(require("../assets/apple.svg")) + ");\n  background-size: 40px 40px;\n}\n.basket[data-v-4e00f6ee] {\n  width: 250px;\n  height: 250px;\n  background-image: url(" + escape(require("../assets/basket.svg")) + ");\n  background-size: 250px 250px;\n}\n\n", ""]);

// exports
